var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.pagination && _vm.pagination.totalResults > 0
    ? _c(
        "div",
        {
          staticClass:
            "u-flex g-layout--align-center g-layout--justify-between g-layout--wrap",
        },
        [
          _c(
            "div",
            { staticClass: "g-display-list-filtering" },
            [
              _c("per-page", { attrs: { pagination: _vm.pagination } }),
              _vm._v(" "),
              _vm.facets && _vm.facets.length
                ? _c(
                    "div",
                    {
                      staticClass:
                        "g-display-list-filtering__item g-display-list-filter-button",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "g-display-list-filter-button__trigger g-button--no-styling",
                          attrs: {
                            type: "button",
                            "aria-label": "Open Filters",
                            "aria-haspopup": "dialog",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.showFacetsDrawer()
                            },
                          },
                        },
                        [
                          _c("span", {
                            staticClass:
                              "g-display-list-filter-button__icon u-icon-filter-sliders",
                            attrs: {
                              "aria-hidden": "true",
                              focusable: "false",
                            },
                          }),
                          _vm._v("\n\t\t\t\tFilter\n\t\t\t"),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pagination && _vm.pagination.totalResults > 0
                ? _c(
                    "div",
                    {
                      staticClass:
                        "g-display-list-filtering__item g-display-list-filtering__product-count g-product-list__product-count",
                    },
                    [
                      _vm._v(
                        "\n\t\t\t" +
                          _vm._s(_vm.pagination.totalResults) +
                          " " +
                          _vm._s(
                            _vm.pagination.totalResults > 1 ? "Items" : "Item"
                          ) +
                          "\n\t\t"
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("sort-by", { attrs: { sorting: _vm.sorting } }),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }